<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: "telefone"
    },
    phone: {
      type: Object,
      required: false,
      default: function() {
        return {
          area_code: "",
          number: "",
          country_code: "55"
        };
      }
    }
  },

  data() {
    return {
      phone_number: ""
    };
  },

  watch: {
    phone_number(val) {
      val = val.replace(/[\(\)-\s]/g, "");
      if (val.length >= 10) {
        this.phone.area_code = val.substr(0, 2);
        this.phone.number = val.substr(2);
      } else {
        this.phone.area_code = "";
        this.phone.number = "";
      }
      this.$emit("input", this.phone);
    }
  },

  mounted() {
    this.phone_number = this.phone.area_code + this.phone.number;
  }
};
</script>

<template>
  <v-text-field
    class="phone"
    :name="label"
    v-model="phone_number"
    :label="label"
    :error-messages="errors.first(label)"
    :error="errors.has(label)"
    v-validate="'required|min:14|max:15'"
    v-mask="['(##) ####-####', '(##) #####-####']"
  />
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Forms/Phone.vue